import React from 'react';

import { Tooltip } from 'antd';

interface IProps {
  show: boolean;
  message: string;
  children: React.ReactNode;
}

export const CustomTooltip = ({ show, message, children }: IProps) => {
  if (!show) return <div>{children}</div>;
  return (
    <Tooltip title={message} placement='left'>
      <div>{children}</div>
    </Tooltip>
  );
};
